export default function FarmSwitcher({
  farms,
  selected,
  onSelect,
}: {
  farms: Array<{ id: string; name: string }>;
  selected: string;
  onSelect: (id: string) => void;
}) {
  return (
    <div role="tablist" className="flex gap-1">
      {farms.map((farm) => {
        const active = farm.id === selected;
        return (
          <button
            key={farm.id}
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(farm.id)}
            className={`text-xs px-3 py-1.5 rounded-md border transition-colors ${
              active
                ? 'bg-emerald-600/80 border-emerald-400/60 text-white'
                : 'bg-white/10 border-white/10 hover:bg-white/15'
            }`}
          >
            {farm.name}
          </button>
        );
      })}
    </div>
  );
}
